export const MESSAGE = {
  COMMON: {
    ADD_SUCCESSFUL: "Insert successful",
    DELETE_SUCCESSFUL: "Delete successful",
    UPDATE_SUCCESSFUL: "Update successful",
    ADD_FAILED: "Insert failed",
    DELETE_FAILED: "Delete failed",
    UPDATE_FAILED: "Update failed",
    INFOR_ERROR: "Please check your information",
  },
  PAYMENTS: {
    GET_ALL: "Get payments error",
    ADD_SUCCESSFUL: "Insert successful",
  },
  PAYMENT_METHODS: {
    GET_ALL: "Get payments method error",
  },
  USERS: {
    GET_ALL: "Get users error",
    SIGN_UP_SUCCESS: "Sign up successful",
    SIGN_UP_FAILED: "Sign up failed",
    SIGN_IN_SUCCESS: "Sign in successful",
    SIGN_IN_FAILED: "Sign in failed",
    CHANGE_PASS_SUCCESS: "Change password successful",
    CHANGE_PASS_FAILED: "Change password failed",
    CHANGE_EMAIL_SUCCESS: "Change email successful",
    CHANGE_EMAIL_FAILED: "Changge email failed",
    GENERATE_API_KEY_SUCCESS: "Generate key successful",
    GENERATE_API_KEY_FAILED: "Generate key failed",
  },
};
